<div class="sc-page">

  <!-- Header strip -->
  <div class="sc-topbar">
    <div class="sc-brand">
      <i class="pe-7s-bookmarks"></i>
      <span>BookBridge</span>
    </div>
    <button class="sc-logout-btn" (click)="logout()">
      <i class="pe-7s-power"></i> Sign out
    </button>
  </div>

  <!-- Card -->
  <div class="sc-card">

    <div class="sc-welcome">
      <div class="sc-avatar">{{ (currentUser?.name || 'M').charAt(0).toUpperCase() }}</div>
      <div>
        <h2 class="sc-greeting">Welcome, {{ currentUser?.name || 'Manager' }}</h2>
        <p class="sc-sub">You manage {{ centers.length }} centers. Select one to continue.</p>
      </div>
    </div>

    <div class="sc-centers-grid">
      <button class="sc-center-card" *ngFor="let c of centers" (click)="select(c)">
        <div class="sc-center-icon">
          <i class="pe-7s-home"></i>
        </div>
        <div class="sc-center-info">
          <div class="sc-center-name">{{ c.centerName }}</div>
          <div class="sc-center-meta" *ngIf="c.area || c.pincode">
            <span *ngIf="c.area">{{ c.area }}</span>
            <span *ngIf="c.area && c.pincode"> · </span>
            <span *ngIf="c.pincode">{{ c.pincode }}</span>
          </div>
          <div class="sc-center-id">{{ c.centerId }}</div>
        </div>
        <i class="pe-7s-angle-right sc-arrow"></i>
      </button>
    </div>

  </div>

</div>
